<template>
  <div>
    <div>
      <!-- Company Logo -->
      <company-logo />

      <!-- Title -->
      <list-header title="Account exist" />

      <div class="p-4 text-start">
        There are more than 1 profiles with the same mobile number. Kindly
        contact the salon for CWA activation.
      </div>
    </div>

    <div class="style-bottom mb-2">
      <span
        class="scss-click-effect scss-text-blue scss-clickable"
        @click="goToSignUpPage"
        >Back to Sign up</span
      >
    </div>
  </div>
</template>

<script>
import ListHeader from "@/components/ListHeader.vue";
import CompanyLogo from "@/components/CompanyLogo.vue";

export default {
  name: "MultipleProfile",
  components: {
    ListHeader,
    CompanyLogo,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    goToSignUpPage() {
      this.$router.push("/signup");
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.style-bottom {
  position: fixed;
  bottom: 10px;
  right: 0;
  width: 95%;
  left: 50%;
  transform: translateX(-50%);
}
</style>
